module.exports = __webpack_public_path__ + "static/media/bh.be88a30c.svg";